import environment from '../../../environment';
import { NOTIFY_TYPE, notifyError, notifySuccess } from '../../../shared/notify';
import fetch from '../../fetch';

const LayerControls = (name) => require('../../../controls/index').get(name);

const grouping = (() => {
    const _handleResponse = (message) => {
        LayerControls('MarkedArea').getLayer().clear();
        LayerControls('MarkedArea').getLayer().show();
        LayerControls('MarkedArea').check(true);

        if (message.type === NOTIFY_TYPE.SUCCESS) {
            notifySuccess(message);
        } else {
            notifyError(message);
        }
    };

    const get = id =>
        fetch({
            async: false,
            type: 'GET',
            ContentType: 'application/json; charset=utf-8',
            url: `${environment.get('API_HOST')}/agrupamento/obter/`,
            data: {
                id
            }
        });

    const add = req => {
        const _success = () => {
            const message = { type: NOTIFY_TYPE.SUCCESS, text: 'Área criada com sucesso' };
            _handleResponse(message);
        };

        return fetch({
            type: 'POST',
            url: `${environment.get('API_HOST')}/agrupamento/inserirareademarcada`,
            header: {
                'X-UIKey': 'search-operational-area-create'
            },
            data: JSON.stringify(req)
        }).then(_success, notifyError);
    };

    const remove = id => {
        const _success = () => {
            const message = { type: NOTIFY_TYPE.SUCCESS, text: 'Área removida com sucesso' };
            _handleResponse(message);
        };

        return fetch({
            url: `${environment.get('API_HOST')}/agrupamento/ExcluirAreaDemarcada?id=${id}`,
            header: {
                'X-UIKey': 'Operational-area-remove'
            },
            type: 'POST'
        }).then(_success, notifyError);
    };

    const update = req => {
        const _success = () => {
            const message = { type: NOTIFY_TYPE.SUCCESS, text: 'Área atualizada com sucesso' };
            _handleResponse(message);
        };

        return fetch({
            type: 'POST',
            url: `${environment.get('API_HOST')}/agrupamento/atualizarareademarcada`,
            header: {
                'X-UIKey': 'operational-area-edit'
            },
            data: JSON.stringify(req)
        }).then(_success, notifyError);
    };

    update.MVA = req => {
        const _success = () => {
            const message = { type: NOTIFY_TYPE.SUCCESS, text: 'Área atualizada com sucesso' };
            notifySuccess(message);
            LayerControls('MarkedArea').reload();
        };

        return fetch({
            type: 'POST',
            url: `${environment.get('API_HOST')}/agrupamento/AtualizarAnoExpansao`,
            data: JSON.stringify(req)
        }).then(_success, notifyError);
    };

    return {
        add,
        get,
        remove,
        update
    };
})();

export default grouping;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/grouping/index.js